import React, { useEffect, useCallback, useState, useReducer, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { ButtonBase } from "@material-ui/core";
import { Tables, Spinner, DatePickerComponent, AutocompleteComponent ,NoContentComponent } from '../../../Components';
import { GetAllLostLeads, OrganizationUserSearch, GetLeads  , GetTeam  , ExportAllLostLeadsLogsAPI} from '../../../Services';
import { GetAdvanceSearchRotationScheme } from '../../../Services/RotaionSchemaService/RotationSchemaService';
import { bottomBoxComponentUpdate , getDownloadableLink  , showWarn , showError, showinfo, showSuccess  } from '../../../Helper';
import { PaginationComponent } from '../../../Components/PaginationComponent/PaginationComponent';
import { DateRangePickerComponent } from '../../../Components/Controls/DateRangePickerComponent/DateRangePickerComponent';

import moment from 'moment';
import { result } from 'lodash';

export const LostLeadsView = ({ }) => {
  const translationPath = '';
  const parentTranslationPath = 'UsersLoginHistoryView';
  const { t } = useTranslation(parentTranslationPath);
  const dateRangeDefault = {
    startDate: null,
    endDate: null,
    key: 'selection',
  };
  const searchTimer = useRef(null);
  const [isLoading, setIsLoading] = useState({
    leads: false,
    agents: false,
    lostLeads: false,
    rotationSchemas: false,
    teams : false  ,
    export: false 
  });
  const [dateFilter, setDateFilter] = useState(dateRangeDefault);
  const [sortBy, setSortBy] = useState({});

  const reducer = useCallback((state, action) => {
    if (action.id !== 'edit') return { ...state, [action.id]: action.value };
    return {
      ...action.value,
    };
  }, []);
  const [data, setData] = useReducer(reducer, {
    lostLeads: [],
    agents: [],
    leads: [],
    rotationSchemas: [],
    teamsName : []
  });
  const [filter, setFilter] = useReducer(reducer, {
    pageIndex: 0,
    pageSize: parseInt(localStorage.getItem("Pagination")) || 25,
    leadName: null,
    agentId: null,
    rotationSchemeId: null,
    assignmentDateFrom: null,
    assignmentDateTo: null,
    teamName : null ,
    agentName: null,
  });

  const [selected, setSelected] = useReducer(reducer, {
    lead: null,
    agent: null,
    rotationSchema: null,
    assignmentDateFrom: null,
    assignmentDateTo: null,
    teamsName :null
  });

  const onPageIndexChanged = (newValue) => {
    setFilter({
      id: 'pageIndex',
      value: newValue,
    });
  };
  const onPageSizeChanged = (newValue) => {
    setFilter({
      id: 'pageSize',
      value: newValue,
    });
  };

  const getAllLostLeads = useCallback(async () => {
    setIsLoading((item) => ({ ...item, lostLeads: true }));

    const body = {
      ...filter,
      filterBy: sortBy?.filterBy,
      orderBy: sortBy?.orderBy,
      pageIndex: filter.pageIndex + 1,
    };

    const res = await GetAllLostLeads(body);
    if (!(res && res.status && res.status !== 200)) {
      setData({ id: 'lostLeads', value: res || {} });
    }else 
    setData({ id: 'lostLeads', value: {
      totalCount :  0 , result : []

    }});

    setIsLoading((item) => ({ ...item, lostLeads: false }));
  }, [filter, sortBy]);


  const getAllAgents = useCallback(async () => {
    setIsLoading((item) => ({ ...item, agents: true }));

    const res = await OrganizationUserSearch({});
    if (!(res && res.status && res.status !== 200)) {
      setData({ id: 'agents', value: res?.result || [] });
    }
    setIsLoading((item) => ({ ...item, agents: false }));
  }, []);

  const GetAllTeamAPI = useCallback(async (search) => {
    setIsLoading((item) => ({ ...item, teams: true }));

    const res = await GetTeam(1,150,search||'');
    if (!(res && res.status && res.status !== 200)) {
      setData({ id: 'teamsName', value: res?.result || [] });
    }
    setIsLoading((item) => ({ ...item, teams: false }));
  }, []);

  const getAllLeads = useCallback(
    async (value) => {
      setIsLoading((item) => ({ ...item, leads: true }));
      const response = await GetLeads({
        pageIndex: 0,
        pageSize: 10,
        search: value,
      });
      if (!(response && response.status && response.status !== 200))
        setData({ id: 'leads', value: (response && response.result) || [] });
      else setData({ id: 'leads', value: [] });

      setIsLoading((item) => ({ ...item, leads: false }));
    },
    [filter]
  );

  const getAllRotationSchemas = useCallback(async () => {
    setIsLoading((item) => ({ ...item, rotationSchemas: true }));
    const res = await GetAdvanceSearchRotationScheme({ pageSize: 25, pageIndex: 1 });
    if (!(res && res.status && res.status !== 200)) setData({ id: 'rotationSchemas', value: res?.result || [] });
    else setData({ id: 'rotationSchemas', value: [] });

    setIsLoading((item) => ({ ...item, rotationSchemas: false }));
  }, []);

    const exportHandler = useCallback(async () => {
  
      if (data?.lostLeads?.totalCount !== 0 ) {
        setIsLoading((item) => ({ ...item, export: true }));
        showinfo(t(`${translationPath}export-started-your-lost-leads-log-export-is-in-progress`)) ;
       let    assignmentDateFrom = null  ;
        let assignmentDateTo = null ; 


        if (dateFilter && dateFilter.startDate && dateFilter.endDate)
          {
            assignmentDateFrom = moment(dateFilter.startDate)
               .startOf("day")
               .format("YYYY-MM-DDTHH:mm:ss");
               assignmentDateTo = moment(dateFilter.endDate).format(
             "YYYY-MM-DDTHH:mm:ss")
           }
        const res = await ExportAllLostLeadsLogsAPI({
          ...filter,
          pageIndex: 1,
          pageSize: (filter.pageSize),
          assignmentDateFrom  , 
          assignmentDateTo , 
          filterBy: sortBy?.filterBy,
          orderBy: sortBy?.orderBy,
        }
        );
        if (!(res && res.status && res.status !== 200))
          {
            if (res && res.uuid) {
              showSuccess(t(`${translationPath}export-completed-your-lost-leads-log-exported-successfully`)) ;

              try {
                const link = document.createElement("a");
                link.setAttribute(
                  "download",
                  res.fileName || "LostLeadsLogs"
                );
                link.href = getDownloadableLink(res.uuid || res.documentId);
                document.body.appendChild(link);
                link.click();
                link.remove();
                  
              } catch (error) {}
            }
          }
        else showError(t(`${translationPath}export-failed-there-was-an-issue-processing-your-request-please-try-again`));
         
        setIsLoading((item) => ({ ...item, export: false }));
      } else showWarn(t(`${translationPath}we-need-data-to-export-lost-leads-logs`));
    }, [filter , sortBy , dateFilter , data.lostLeads ]);

  const transactionLinksActionClicked = 
  (item, key) => async (event) => {
    event.stopPropagation();
    if (key === "lead" && item.leadId && item.leadClass){
      const formType = (item.leadClass === 'Landlord' || item.leadClass === 'Seller' ) ? 1 : 2  ; 
    
      window.open(
        `/home/leads/lead-profile-edit?formType=${formType}&id=${
          item.leadId 
        }&leadClass=${item.leadClass}`,
        "_blank"
      );
    }
  };

  useEffect(() => {
    getAllLostLeads();
  }, [getAllLostLeads]);

  useEffect(() => {
    getAllRotationSchemas();
    getAllAgents();
    getAllLeads();
    GetAllTeamAPI()
  }, []);


  useEffect(() => {
    bottomBoxComponentUpdate(
      <PaginationComponent
        pageIndex={filter.pageIndex}
        pageSize={filter.pageSize}
        totalCount={data?.lostLeads?.totalCount || 0}
        onPageIndexChanged={onPageIndexChanged}
        onPageSizeChanged={onPageSizeChanged}
      />
    );
  },[filter , data.lostLeads]);

  useEffect(
    () => () => {
      bottomBoxComponentUpdate(null);
    }, []
  );

  return (
    <div className="lost-leads-wrapper">
      <Spinner isActive={isLoading.lostLeads || isLoading.export} isAbsolute />
      <div className="fa-end d-flex-column m-2">
        <div className="d-flex w-50">
          <div className="mr-2-reversed w-100">
            <AutocompleteComponent
              idRef="LeadNameRef"
              isLoading={isLoading.leads}
              multiple={false}
              data={data.leads || []}
              value={selected.lead}
              chipsLabel={(option) => option?.lead?.contact_name?.name || ""}
              displayLabel={(option) => option?.lead?.contact_name?.name || ""}
              withoutSearchButton
              inputPlaceholder={`Lead`}
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
              onKeyDown={() => {
                setSelected({ id: "lead", value: null });
              }}
              onInputKeyUp={(e) => {
                const searchText = e?.target?.value;
                if (searchTimer.current) clearTimeout(searchTimer.current);
                searchTimer.current = setTimeout(() => {
                  getAllLeads(searchText);
                }, 700);
              }}
              onChange={(event, newValue) => {
                setFilter({
                  id: "leadName",
                  value: newValue?.lead?.contact_name?.name || null,
                });
                setSelected({ id: "lead", value: newValue });
              }}
            />
          </div>
          <div className="mr-2-reversed w-100">
            <div className="">
              <AutocompleteComponent
                idRef="agentIdRef"
                isLoading={isLoading.agents}
                multiple={false}
                data={data.agents || []}
                value={selected.agent}
                chipsLabel={(option) => option.fullName || ""}
                displayLabel={(option) => option.fullName || ""}
                withoutSearchButton
                inputPlaceholder={`Agent`}
                parentTranslationPath={parentTranslationPath}
                translationPath={translationPath}
                onChange={(event, newValue) => {
                  setFilter({ id: "agentId", value: newValue?.id || null });
                  setSelected({ id: "agent", value: newValue });
                }}
              />
            </div>
            <div className="w-50 mr-2"></div>
          </div>
        </div>
        <div className="d-flex my-2 w-50 mt-2">
          <div className="mr-2-reversed w-50">
            <AutocompleteComponent
              idRef="rotationSchemaRef"
              inputPlaceholder={`Roration Schemes`}
              data={data.rotationSchemas || []}
              selectedValues={selected.rotationSchema}
              multiple={false}
              displayLabel={(option) => (option && option.label) || ""}
              chipsLabel={(option) => (option && option.label) || ""}
              isLoading={isLoading.rotationSchemas}
              withoutSearchButton
              parentTranslationPath={translationPath}
              translationPath={""}
              onChange={(e, newValue) => {
                setFilter({
                  id: "rotationSchemeId",
                  value: newValue?.rotationSchemeId || null,
                });
                setSelected({ id: "rotationSchema", value: newValue });
              }}
            />
          </div>
          <div className="lost-leads-date mr-2-reversed w-50">
            <DateRangePickerComponent
              idRef="daterangeRef"
              onClearClicked={() => setDateFilter(dateRangeDefault)}
              ranges={[dateFilter]}
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
              onDateChanged={(selectedDate) => {
                setDateFilter({ ...selectedDate.selection });

                const endDate = selectedDate?.selection?.endDate;
                const startDate = selectedDate?.selection?.startDate;

                setFilter({
                  id: "edit",
                  value: {
                    ...filter,
                    assignmentDateFrom: startDate
                      ? moment(startDate)
                          .startOf("day")
                          .format("YYYY-MM-DDTHH:mm:ss")
                      : null,
                    assignmentDateTo: endDate
                      ? moment(endDate)
                          .endOf("day")
                          .format("YYYY-MM-DDTHH:mm:ss")
                      : null,
                  },
                });
              }}
            />
          </div>
        </div>
        <div className="d-flex w-50">
          <div className="">
            <AutocompleteComponent
              idRef="teamsIdRef"
              isLoading={isLoading.teams}
              multiple={true}
              data={data.teamsName || []}
              value={selected?.teamsName || []}
              chipsLabel={(option) => option.teamsName || ""}
              displayLabel={(option) => option.teamsName || ""}
              withoutSearchButton
              inputPlaceholder={`teamsName`}
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
              onChange={(event, newValues) => {
                const newFilters = newValues.map((i) => i.teamsId);
                setFilter({ id: "teamName", value: newFilters.length > 0 ?  newFilters : null });
                setSelected({ id: "teamsName", value: newValues });
                if(!newFilters.length)
                GetAllTeamAPI("");

              }}
              onInputKeyUp={(e) => {
                const newValue = e?.target?.value || "";
                if (searchTimer.current) clearTimeout(searchTimer.current);
                searchTimer.current = setTimeout(() => {
                  GetAllTeamAPI(newValue || "");
                }, 700);
              }}
              filterOptions={(options) => options}
              filterSelectedOptions

              getOptionSelected={(option) =>
                (selected &&
                  selected.teamsName &&
                  selected.teamsName?.findIndex(
                    (item) => item?.teamsId === option?.teamsId
                  ) !== -1) ||
                false
              }
            />
          </div>
        </div>
         <div className="d-flex px-2 w-50 p-relative">
          <div className="d-flex-v-center-h-end">
            <ButtonBase
              onClick={exportHandler}
              id="onClearedAllFiltersref"
              className="btns theme-solid  mt-2"
            >
              <span className="mdi  mdi-share-variant m-1" />
              {t(`${translationPath}export-lost-leads-logs`)}
            </ButtonBase>
          </div>
        </div> 
      </div>
      <div className="m-4">
        {data?.lostLeads?.totalCount > 0 && (
          <Tables
            data={data?.lostLeads?.result || []}
            headerData={[
              {
                id: 1,
                label: "Lead Id",
                input: "leadId",
                isSortable: true,
                component: (item) =>
                  item.leadId ? (
                    <a
                      className="c-primary newTabActivites"
                      onClick={transactionLinksActionClicked(item, "lead")}
                    >
                      {item.leadId || "N/A"}
                    </a>
                  ) : (
                    <span> {item.leadId || ""} </span>
                  ),
              },
              {
                id: 2,
                label: "Lead Name",
                input: "lostLeadName",
                isSortable: true,
              },
              {
                id: 3,
                label: "team-Name",
                input: "teamName",
                isSortable: false,
              },
              {
                id: 4,
                label: "Lead Assignment Date",
                input: "createdOn",
                component: (item) => (
                  <span>
                    {item.assignmentDate &&
                      moment(item.assignmentDate).format("DD/MM/YYYY")}
                  </span>
                ),
                isDate: true,
                dateFormat: "DD/MM/YYYY",
                isSortable: true,
              },
              {
                id: 5,
                label: "Agent Name",
                input: "agentName",
                isSortable: true,
              },
              {
                id: 6,
                label: "Rotation Schema",
                component: (item) => (
                  <span>
                    {item.agentSchemaMatchingDtos &&
                      item.agentSchemaMatchingDtos.map(
                        (item) => `${item.rotationSchemeName},`
                      )}
                  </span>
                ),
                // isSortable: true,
              },
            ]}
            setSortBy={setSortBy}
            itemsPerPage={filter.pageSize}
            activePage={filter.pageIndex}
            translationPath={translationPath}
            parentTranslationPath={parentTranslationPath}
            defaultActions={[]}
            onPageIndexChanged={onPageIndexChanged}
            onPageSizeChanged={onPageSizeChanged}
            totalItems={data?.lostLeads?.totalCount || 0}
          />
        )}

        {data?.lostLeads?.totalCount === 0 && <NoContentComponent />}
      </div>
    </div>
  );
};
